module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAABD0lEQVQoU4WSMSvFYRTGf4+kLGJQBouPgLIZ1VVsdxSJwabLR7ArFoNcBhZWJorFdq12BhOzDHr03v5H5/6j+05v5zy/0znPOSI925NAC2gAU8AH8AQcSLovUoXe9jJwDozkIul/KGm7C9ieAx6BwX/EEd4LoAPM1sSvwDgwnLuW7Zmqz4iXvhuSOrZHgUtgIZIFWAPOUpVdSftptmLECzDQHdr2JnCcgBVJFwkowk9gKIAmcJWAG0lLCVgH2rmlMthbzaE74ASYBnZyLlw6Arb6WFrS7wGMAc/ARB9oNW96HngIN/4A25I2foFq43WLg7sFFiV99wAVVLf5GmhK+uo5vtrVlkM8rY6xJcmR/wEiy2G4IeLQdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/stayPoint.png
// module id = c09d
// module chunks = 2